import React, { useContext, useEffect } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { BEFORE_APP } from 'Components/frameworks/portal/Portal.constants';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS } from 'Components/utils/identifiers/constants';
import { COLORS } from 'Components/utils/color/colors';
import { Layer } from 'Components/frameworks/layer/Layer';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { PriceRemoteServiceList } from 'Components/widgets/price-remote/price-remote-service-list/PriceRemoteServiceList';
import { PriceRemoteContext } from 'Components/widgets/price-remote/PriceRemoteContext';
import type { Service } from 'Components/widgets/product-services/product-service/ProductService';
import 'Components/widgets/product-services/product-service/ProductService';
import { RateMessages } from 'Components/widgets/rate-messages/RateMessages';
type Props = {
  allInclusiveServices?: ReadonlyArray<Service>;
  closeLabel?: string;
  isLoading?: boolean;
  nameRender?: string;
  onBack: () => void;
  children?: React.ReactNode;
  rate?: string;
  shouldDisplayRate?: boolean;
};
export const PriceRemoteDetailsLayer = ({
  allInclusiveServices,
  closeLabel,
  isLoading,
  onBack,
  nameRender,
  children,
  rate,
  shouldDisplayRate,
}: Props) => {
  const [{ isTotalPrice }, setPriceRemoteContext] = useContext(PriceRemoteContext);
  useEffect(() => {
    setPriceRemoteContext({
      isInLayer: true,
    });
    return () => {
      setPriceRemoteContext({
        isInLayer: false,
      });
    };
  }, []);
  const layerHeaderTitle = t('priceRemote.openAllInclusiveDetails');
  return (
    <Layer
      ariaLabel={layerHeaderTitle}
      ariaLabelledby={ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS}
      bgColor={COLORS.WHITE}
      buttonLeft={{
        label: t('common.backNavigation'),
        iconName: ICONS.ARROW_TAIL_LEFT,
        onClick: onBack,
      }}
      closeLabel={closeLabel}
      hasAnimateEnter
      header={
        <span
          id={ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS}
          className="block w-full text-center"
        >
          {layerHeaderTitle}
        </span>
      }
      onClose={onBack}
      portalName={nameRender || BEFORE_APP}
    >
      <div
        className={classnames(
          'scroll-y flex flex-col items-center p-15 transition-opacity duration-250 ease-in',
          'h-[calc(100% -(250px-60px))]',
          {
            'opacity-25': isLoading,
          },
        )}
        data-testid="price-remote-details-layer-container"
      >
        {isTotalPrice ? (
          <div className="pb-5 pt-20 text-center text-14 font-bold text-sienna lg:pt-10">
            {t('priceRemote.priceForAll')}
          </div>
        ) : null}
        {allInclusiveServices && allInclusiveServices.length > 0 ? (
          <PriceRemoteServiceList className="w-full" services={allInclusiveServices} />
        ) : (
          <Spinner size="small" />
        )}
        {!isLoading && shouldDisplayRate && (
          <div className="text-start">
            <RateMessages rate={rate} />
          </div>
        )}
      </div>
      {children}
    </Layer>
  );
};
